export default function(http) {
  return {
      // queryByPage(data){
      //     return http.json({
      //         url: `/vote/query`,
      //         data
      //     });
      // },
      queryByPage(data){
          return http.get(
              `/vote/list?articleId=${data.articleId}`
          );
      },
      /**
       * 获取详情
       * @param data
       * @return {*}
       */
      getInfo(data) {
          return http.json({
              url: `/voteContent/get?id=${data.id}`
          })
      },

      saveInfo(data){
          return http.json({
              url: `/voteContent/save`,
              data
          });
      },
      editInfo(data){
          return http.json({
              url: `/voteContent/edit`,
              data
          });
      },
      /**
       * 删除
       * @param data
       * @return {*}
       */
      delete(data) {
          return http.get(
              `/voteContent/delete?id=${data.id}`
          )
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/vote.js